import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomIcon from './CustomIcon';
import { FilterBoxTooltip } from '../Features/Table/GenericDraggableTable/TableStyles';

const StyledContainer = styled(Box)(({ theme, backgroundColor, hasIcon }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: hasIcon ? '0 8px' : '0 16px',
    backgroundColor: backgroundColor || '#FFEEE8',
    gap: 8,
    borderRadius: hasIcon ? '12px' : '4px',
}));

const CustomTag = ({ text, icon, backgroundColor, fontColor, fontSize, fontWeight, tooltipText, iconProps = {}, containerStyle = {} }) => {
    const hasIcon = !!icon;
    const content = (
        <StyledContainer className='custom-tag-container' backgroundColor={backgroundColor} sx={containerStyle} hasIcon={hasIcon}>
            {icon && <CustomIcon height="16px" width="auto" name={icon} {...iconProps} />}
            <Typography
                variant="fw500s12lh24c444B51"
                sx={{ color: fontColor || '#444B51', fontSize: fontSize || '14px', fontWeight: fontWeight || '400' }}
            >
                {text}
            </Typography>
        </StyledContainer>
    );

    return tooltipText ? (
        <FilterBoxTooltip title={tooltipText} placement="bottom">
            {content}
        </FilterBoxTooltip>
    ) : (
        content
    );
};

export default CustomTag;
